import styled, { css } from "styled-components";
import Modal from "../../designComponents/Modal";
import Typography from "../../designComponents/Typography";
import {
  AcceptButton,
  LabelText,
  SectionTitle,
} from "../Properties/Details/styles";
import { Input, InputGroup } from "./styles";
import { PaymentMethodType } from "./ViewPaymentMethods";

export interface PricingSettings {
  percentageFee: number;
  flatFee: number;
  currency: string;
  paymentMethod?: string;
}
function AddStripeSettings({
  isOpen,
  onClose,
  onAddPress,
  setData,
  initialValues,
  paymentMethods,
}: {
  isOpen: boolean;
  onClose: () => void;
  onAddPress: () => void;
  setData: React.Dispatch<React.SetStateAction<PricingSettings>>;
  initialValues: PricingSettings;
  paymentMethods: PaymentMethodType[];
}) {
  const handleChange = (field: keyof PricingSettings, value: string) => {
    const numValue = field === "paymentMethod" ? value : parseFloat(value) || 0;
    setData((prev) => ({
      ...prev,
      [field]: numValue,
    }));
  };

  return (
    <Modal
      isOpen={isOpen}
      halfWidth={true}
      onClose={onClose}
      title="Add Stripe Fee"
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div>
          <SectionTitle>Stripe Fee</SectionTitle>
          <InputGroup>
            <LabelText>Percentage Fee (%)</LabelText>
            <Input
              type="number"
              value={initialValues.percentageFee}
              onChange={(e) => handleChange("percentageFee", e.target.value)}
              placeholder="Enter per day rate"
            />
          </InputGroup>

          <InputGroup>
            <LabelText>Flat Fee(€)</LabelText>
            <Input
              type="number"
              value={initialValues.flatFee}
              onChange={(e) => handleChange("flatFee", e.target.value)}
              placeholder="Enter weekly discount"
              min="0"
              max="100"
            />
          </InputGroup>
          <InputGroup>
            <LabelText>Payment Methods</LabelText>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
              {paymentMethods?.map((pm) => {
                return (
                  <SelectButtonStyled
                    $selected={pm?.key === initialValues?.paymentMethod}
                    onClick={() => {
                      handleChange("paymentMethod", pm.key);
                    }}
                    key={pm.key}
                  >
                    <Typography color="light.white" size={"title"}>
                      {pm.title}
                    </Typography>
                  </SelectButtonStyled>
                );
              })}
            </div>
          </InputGroup>
        </div>
      </div>
      <AcceptButton onClick={onAddPress}>Save</AcceptButton>
    </Modal>
  );
}

export default AddStripeSettings;

const SelectButtonStyled = styled.div<{ $selected: boolean }>`
  box-shadow: none;
  border: none;
  padding: 4px 16px;
  cursor: pointer;
  border-radius: 4px;

  background-color: hsl(190, 44%, 75%);
  ${({ $selected }) =>
    $selected
      ? css`
          background-color: hsl(190, 44%, 50%);
        `
      : css``}
`;
